import {
  Box,
  Chip,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  SelectProps,
} from "@mui/material";

type Props = Partial<SelectProps<string[]>> & {
  list: string[];
  minWidth?: string;
  errors?: string[];
  onChangeValues: (values: string[]) => void;
};

export const MultipleChipSelect = ({
  list,
  value,
  children,
  fullWidth,
  placeholder,
  errors = [],
  size = "small",
  onChangeValues,
  minWidth = "300px",
  ...props
}: Props) => {
  const renderMenu = (menuList: string[]) => {
    return menuList.map((item) => {
      return (
        <MenuItem key={item} value={item}>
          {item}
        </MenuItem>
      );
    });
  };

  const renderValues = (selected: string[]) => {
    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {selected.map((value) => (
          <Chip
            key={value}
            size="small"
            label={value}
            color={errors.includes(value) ? "error" : undefined}
          />
        ))}
      </Box>
    );
  };

  return (
    <FormControl sx={{ minWidth }} size={size} fullWidth={fullWidth}>
      <InputLabel>{placeholder}</InputLabel>
      <Select
        {...props}
        multiple
        size={size}
        value={value}
        label={placeholder}
        placeholder={placeholder}
        renderValue={renderValues}
        onChange={(event) => onChangeValues(event.target.value as string[])}
      >
        {children ? children : renderMenu(list)}
      </Select>
    </FormControl>
  );
};
